// ThemeContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider, CssBaseline } from '@mui/material';

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

const getMuiTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: '#0A2540' },      // Deep Blue
      secondary: { main: '#2EA1B6' },    // Vibrant Teal
      background: {
        default: mode === 'dark' ? '#0b1117' : '#f8fafc',
        paper:   mode === 'dark' ? '#0f172a' : '#ffffff',
      },
      text: {
        primary: mode === 'dark' ? '#e2e8f0' : '#0A2540',
        secondary: mode === 'dark' ? '#94a3b8' : '#546e7a',
      },
    },
    typography: {
      // Inter variable font with sensible fallbacks
      fontFamily:
        "'Inter Variable', 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      h4: {
        fontWeight: 600,
        letterSpacing: '0.2px',
      },
      body1: { lineHeight: 1.55 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: { borderRadius: 12 },
  });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));

  const muiTheme = getMuiTheme(theme === 'light' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <MUIThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
